export enum DisciplineKey {
  ProjectPrincipal = 'ProjectPrincipal',
  ProjectManagement = 'ProjectManagement',
  QaQc = 'QaQc',
  General = 'General',
  Mechanical = 'Mechanical',
  Electrical = 'Electrical',
  SiteCivil = 'SiteCivil',
  TechnicalAssistant = 'TechnicalAssistant',
  SubjectMaterExpert = 'SubjectMaterExpert',
}
/**
 * The discipline numbers the server actually sends.
 *
 * These are positions in a C# enum (EstimateDiscipline), so they are decided by the order the
 * members are declared in and by nothing else. This list had its own order - QaQc second, General
 * third - and four of the nine disagreed with the server's: a rate card row for General arrived as
 * 2 and was read back as QaQc, Electrical as SiteCivil, and so on. Nothing pointed it out because
 * both sides had a plausible name for every number.
 *
 * Only the labor rate card sends a discipline as a number; an estimate sends its name. So this is
 * read when a card row has no name of the firm's own, which is exactly when the label matters
 * most - it is the only thing naming that row.
 *
 * Custom is on the end because the server has it. A custom row always carries a name, so the
 * label is a fallback that should not be reached, rather than one that cannot be.
 */
export enum ReverseDisciplineKey {
  ProjectPrincipal = 0,
  ProjectManagement = 1,
  General = 2,
  Electrical = 3,
  Mechanical = 4,
  SiteCivil = 5,
  QaQc = 6,
  TechnicalAssistant = 7,
  SubjectMaterExpert = 8,
  Custom = 9,
}

export enum EstimateTypeKey {
  IndependentCostEstimate = 'IndependentCostEstimate',
  IndependentCostReview = 'IndependentCostReview',
}

export enum FeeType {
  Generated = 'Generated',
  Manual = 'Manual',
  Negotiated = 'Negotiated',
}

export enum PhaseTypeKey {
  Concept = 'Concept',
  Schematic = 'Schematic',
  DesignDoc = 'DesignDoc',
  ConstructionDoc = 'ConstructionDoc',
  Proposal = 'Proposal',
}

export enum ProjectStatus {
  Unknown = 'Unknown',
  Draft = 'Draft',
  New = 'New',
  Submitted = 'Submitted',
  Accepted = 'Accepted',
  FeeSelected = 'FeeSelected',
  FeeReady = 'FeeReady',
  FeeCounter = 'FeeCounter',
  Approved = 'Approved',
  InProgress = 'InProgress',
  Complete = 'Complete',
  Rejected = 'Rejected',
  Canceled = 'Canceled',
  SummaryReady = 'SummaryReady',
}

export enum ProjectTypeSource {
  Ciqs = 'Ciqs',
  Cmd = 'Cmd',
  User = 'User',
}

export interface ProjectType {
  id: string;
  category: number;
  subcategory: number;
  type: string;
  constructionCategory: string;
  projectCategory: string;
  source: string;
}

export interface ProjectContentCategoryCount {
  projectId: string;
  phaseId: string;
  category: string;
  count: number;
}
